import {_get, _post} from "./Axios";

export default class WorkingFormatApi {
    static get(koas_code) {
        return _get('/booking/WorkingFormat/get_by_koas/' + koas_code)
    }

    static detail(id) {
        return _get('/booking/WorkingFormat/detail/' + id)
    }

    static uploadAdditional(booking_code, content, original_name) {
        return _post('/booking/WorkingFormat/upload_additional/' + booking_code, {
            content,
            original_name,
        })
    }

    static deleteAdditional(id) {
        return _post('/booking/WorkingFormat/delete_additional/' + id)
    }

    static getAdditional(booking_code) {
        return _get('/booking/WorkingFormat/additional/' + booking_code)
    }
}